import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ResponsiveDialog from '@sophocles/components/ResponsiveDialog';
import useDeleteConfirm from '@sophocles/hooks/useDeleteConfirm';

// Filled multiline centers a short string in the box (MuiInputBase-root's
// align-items: center); anchor to the top so typed text lays out from line
// 1 down, matching the pattern SettingsTextField documents.
const MULTILINE_SX = {
  '& .MuiInputBase-root.MuiInputBase-multiline': {
    alignItems: 'flex-start',
  },
  '& .MuiInputBase-inputMultiline': {
    alignSelf: 'flex-start',
    padding: '0 !important',
  },
};

function PhotoEditDialog({ photo, open, onClose, onDelete, onSubmit }) {
  const { t } = useTranslation();
  const { confirmDelete, dialogElement: deleteConfirmDialog } = useDeleteConfirm();
  const [editablePhoto, setEditablePhoto] = useState(photo);

  const extraActions = (
    <div>
      <Button
        color="error"
        onClick={() => {
          confirmDelete(photo, {
            entityLabel: t('general.image'),
            onConfirm: deletedPhoto => onDelete(deletedPhoto.id),
          });
        }}
        sx={{ mr: 1 }}
      >
        {t('actions.delete', 'Delete')}
      </Button>
      {deleteConfirmDialog}
    </div>
  );

  return (
    <ResponsiveDialog
      title={t('media.editPhoto', 'Edit Photo')}
      open={open}
      extraActions={extraActions}
      onSubmit={() => {
        onSubmit(editablePhoto);
      }}
      onClose={onClose}
    >
      <div>
        {photo?.image ? (
          <img src={photo.image} width="100" height="100" alt={t('media.photoAlt', 'Photo')} />
        ) : (
          <div
            style={{
              height: '100px',
              width: '100px',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border-default)',
            }}
          >
            <span>{t('media.photoNotFound', 'Photo Not Found ')}</span>
          </div>
        )}
      </div>

      <div style={{ flexGrow: 1, paddingLeft: '10px' }}>
        <span>{t('media.updatePhotoCommentPrompt', 'Click Submit to update the photo comment. ')}</span>
        {editablePhoto && (
          <TextField
            label={t('media.photoComment', 'Photo Comment')}
            fullWidth={true}
            multiline={true}
            onChange={e => {
              setEditablePhoto({ ...editablePhoto, comment: e.target.value });
            }}
            value={editablePhoto.comment}
            sx={[{ mt: 2 }, MULTILINE_SX]}
          />
        )}
      </div>
    </ResponsiveDialog>
  );
}

export default PhotoEditDialog;
